<template>
    <div :class="[
             type ? 'app-alert--' + type : ''
         ]" 
         class="app-alert">
        <span v-if="$slots.title || type == 'error'" class="alert-title">
            <slot name="title">Error</slot>
        </span>
        <span v-if="$slots.default">
            <slot/>
        </span>
    </div>
</template>

<script>
export default {
    name: 'app-alert',
    props: {
        type: {
            type: String,
            default: 'info'
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.app-alert
    padding: 10px 20px
    margin: 10px 0px
    border-radius: 12px

    &.app-alert--info
        background: $light-blue
        color: $darker-blue

    &.app-alert--success
        background: $light-green
        color: $darker-green

    &.app-alert--error
        background: $light-red
        color: $dark-red

    .alert-buttons
        width: 100%
        margin-top: 10px

    .alert-title
        display: block
        font-weight: bold
</style>